import React from "react";

type TSection = {
  children: React.ReactNode;
  className?: string;
}

const Section = ({children, className}: TSection) => {
  return (
    <section className={`border-b-8 last:border-0 ${className}`}>
      {children}
    </section>
  )
}

export default Section;
